import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hrMasterDepartmentsAction } from '../actions/hrActions'
import Notification from '../components/Notification'
import Progress from '../components/Progress'
import Controls from '../components/controls/Controls'
import Popup from '../components/Popup'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import PageHeader from '../components/PageHeader'
import PeopleOutlineTwoToneIcon from '@material-ui/icons/PeopleOutlineTwoTone'
import AddMasterDepartment from '../components/AddMasterDepartment'
import MaterialTable from 'material-table'

const HRMasterDepartments = ({ history }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })

  const dispatch = useDispatch()
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const hrMasterDpts = useSelector((state) => state.hrMasterDpts)
  const { loading, error, hrMasterDepartments } = hrMasterDpts

  useEffect(() => {
    if (!userInfo) {
      history.push('/')
    }
  }, [dispatch, history, userInfo])

  const [masterDepartments, setMasterDepartments] = useState([])
  const [employees, setEmployees] = useState([])

  useEffect(() => {
    dispatch(hrMasterDepartmentsAction())
  }, [])

  useEffect(() => {
    if (hrMasterDepartments) {
      if (
        hrMasterDepartments.role === 'Admin' ||
        hrMasterDepartments.role === 'HR'
      ) {
        setMasterDepartments(hrMasterDepartments.data)
      } else {
        history.push('/dashboard')
      }
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        type: 'error',
      })
    }
  }, [hrMasterDepartments, error])

  const [openPopup, setOpenPopup] = useState(false)
  const [departmentForEdit, setDepartmentForEdit] = useState(null)

  const openInPopup = (item) => {
    setDepartmentForEdit(item)
    setOpenPopup(true)
  }

  const openAdd = () => {
    setDepartmentForEdit(null)
    setOpenPopup(true)
  }

  // Table
  const headCells = [
    {
      field: 'name',
      title: 'Name',
    },
    {
      field: 'departments',
      title: 'Departments',
    },
    {
      field: 'addedOn',
      title: 'Added On',
    },
    {
      field: 'actions',
      title: 'Actions',
      render: (rowData) => (
        <Controls.ActionButton color='primary'>
          <EditOutlinedIcon
            fontSize='small'
            onClick={() => openInPopup(rowData)}
          />
        </Controls.ActionButton>
      ),
    },
  ]

  return (
    <>
      {loading ? (
        <Progress />
      ) : (
        <>
          {error ? (
            <Notification notify={notify} setNotify={setNotify} />
          ) : (
            <>
              <PageHeader
                title='Master Departments'
                subtitle='Shows list of master departments in the organisations'
                icon={<PeopleOutlineTwoToneIcon fontSize='medium' />}
              />
              <MaterialTable
                style={{ margin: '0 20px' }}
                title='Master Departments'
                columns={headCells}
                data={masterDepartments}
                options={{
                  exportButton: true,
                  search: true,
                  exportAllData: true,
                }}
                actions={[
                  {
                    icon: 'add',
                    tooltip: 'Add Master Department',
                    isFreeAction: true,
                    onClick: () => openAdd(),
                  },
                ]}
              />
              <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Add Master Department'
              >
                <AddMasterDepartment
                  departmentForEdit={departmentForEdit}
                  setOpenPopup={setOpenPopup}
                />
              </Popup>
            </>
          )}
        </>
      )}
    </>
  )
}

export default HRMasterDepartments
